import { Footer, Header, QuemSomosPainel } from '../../molecules'

export function QuemSomosTemplate() {
  return (
    <>
      <Header />
      <QuemSomosPainel />
      <Footer />
    </>
  )
}
